import { ReactNode } from 'react';
import { Route } from 'react-router-dom';
import { RoutesExtensionInterface } from '../../../../extension/interface/routes.extension.interface';
import ITLeasingConnectPage from '../../../../page/itLeasing/ITLeasingConnectPage';
import ITLeasingLearnMorePage from '../../../../page/itLeasing/ITLeasingLearnMorePage';
import ITLeasingSettingsPage from '../../../../page/itLeasing/ITLeasingSettingsPage';

export class ITLeasingRoutesExtension extends RoutesExtensionInterface {
  get privateRoutes(): ReactNode {
    return (
      <>
        <Route path="/benefits/it_leasing/settings" element={<ITLeasingSettingsPage />} />
        <Route path="/benefits/it_leasing/connect" element={<ITLeasingConnectPage />} />
        <Route path="/benefits/it_leasing/learnMore" element={<ITLeasingLearnMorePage />} />
      </>
    );
  }
}
